/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Enum_Billingrhytm_MonthlyInputs */



/**

* @param {_Enum_Billingrhytm_MonthlyInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _enum_billingrhytm_monthly = /** @type {((inputs?: _Enum_Billingrhytm_MonthlyInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Enum_Billingrhytm_MonthlyInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Monatlich")
});